import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

class PreferencesCommonListMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      elements: props.field.defaultValue && props.field.defaultValue.length > 0 ?
      props.field.defaultValue : [],
    };
  }

  /* eslint-disable camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {    
    if (!_.isEmpty(nextProps.userPreference)) {
      this.setState(() => ({ elements: nextProps.userPreference._ct._el }));
    }
  }

  handleElementClick = (element, index) => {
    let tempList = this.state.elements;
    if (this.state.elements.includes(element)) {
      tempList = tempList.filter(el => el !== element);
      this.setState(() => ({ elements: tempList }));
      this.props.updatePreferences(this.props.field.dbKey,
        tempList
      );
    } else {
      tempList.splice(index, 0, element);
      this.setState(() => ({ elements: tempList }));
      this.props.updatePreferences(this.props.field.dbKey,
        tempList
      );
    }
  }

  selectAll = () => {
    const formattedElements = this.props.field.values.map(el => el.label);
    this.setState(() => ({
      elements: formattedElements,
    }));
  }

  render() {
    const { field } = this.props;
    return (
      <div className="preference-common-list">
        { field.showAll && field.values.length !== this.state.elements.length &&
          <button
            type = "button"
            className="preference-common-list-show-all"
            onClick={this.selectAll}
          >Show All
          </button>
        }
        <div
          className="preference-common-list-container"
          style={{ width: field.style && field.style.menuWidth,
          paddingRight: field.style && field.style.padding }}
        >
          {field.values.map((element, index) => (
            <div
              key={element.label + index}
              className="preference-common-list-menu"
              onClick={() => this.handleElementClick(element.label, index)}
            >
              { element.imageSrc && <img
                src={element.imageSrc}
                alt={element}
                className={this.state.elements.includes(element.label) ?
                  'preference-common-list-menu-icon' : 'preference-common-list-menu-icon-unchecked'}
              />}
              <input
                type="checkbox"
                checked={this.state.elements.includes(element.label)}
              />
              <label className="preference-common-list-menu-label">{element.label}</label>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

PreferencesCommonListMenu.propTypes = {
  field: PropTypes.shape({
    values: PropTypes.arrayOf(PropTypes.shape({})),
    defaultValue: PropTypes.arrayOf(PropTypes.string),
    dbKey: PropTypes.string,
    showAll: PropTypes.bool,
    style: PropTypes.shape({
      menuWidth: PropTypes.string,
      padding: PropTypes.string,
    }),
  }),
  userPreference: PropTypes.shape({
    _ct: PropTypes.arrayOf(PropTypes.shape({
      _el: PropTypes.arrayOf(PropTypes.shape({})),
    })),
  }),
  updatePreferences: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    userPreference: state.preferences.userPreferences,
  };
}

export default connect(mapStateToProps)(PreferencesCommonListMenu);
